import script from "./PageBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageBanner.vue?vue&type=script&setup=true&lang=ts"

import "./PageBanner.vue?vue&type=style&index=0&id=33d814a6&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33d814a6"]])

export default __exports__